var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDenided(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#FD4D02"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.203 9.13033C8.4959 9.42322 8.97077 9.42322 9.26366 9.13033C9.55656 8.83744 9.55656 8.36256 9.26366 8.06967L8.19399 7L9.26366 5.93033C9.55656 5.63744 9.55656 5.16256 9.26366 4.86967C8.97077 4.57678 8.4959 4.57678 8.203 4.86967L7.13333 5.93934L6.06366 4.86967C5.77077 4.57678 5.2959 4.57678 5.003 4.86967C4.71011 5.16256 4.71011 5.63744 5.003 5.93033L6.07267 7L5.003 8.06967C4.71011 8.36256 4.71011 8.83744 5.003 9.13033C5.2959 9.42322 5.77077 9.42322 6.06366 9.13033L7.13333 8.06066L8.203 9.13033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDenided);
export default __webpack_public_path__ + "static/media/ico-denided.7f777dd57087283dee8952445648a88c.svg";
export { ForwardRef as ReactComponent };